import React, { Component } from "react";
import { adminLogin } from "../../api/api";

class AdminLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      loading: false,
      error: ""
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: ""
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    const { email, password } = this.state;

    if (!email || !password) {
      this.setState({ error: "Please enter email and password" });
      return;
    }

    try {
      this.setState({ loading: true });

      const res = await adminLogin({
        email: email,
        password: password
      });

      // store token
      localStorage.setItem("adminToken", res.data.token);

      // alert("Login successful");

      // redirect to dashboard
      window.location.href = "/admin/dashboard";

    } catch (error) {
      console.error(error);

      this.setState({
        error: "Invalid email or password"
      });

    } finally {
      this.setState({ loading: false });
    }
  };

  render() {

    const { email, password, loading, error } = this.state;

    return (
      <div className="container d-flex justify-content-center align-items-center" style={{height:"100vh"}}>

        <div className="card shadow p-4" style={{width:"400px"}}>

          <h3 className="text-center mb-4">Admin Login</h3>

          {error && (
            <div className="alert alert-danger">
              {error}
            </div>
          )}

          <form onSubmit={this.handleSubmit}>

            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="Enter admin email"
                value={email}
                onChange={this.handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Password</label>
              <input
                type="password"
                name="password"
                className="form-control"
                placeholder="Enter password"
                value={password}
                onChange={this.handleChange}
              />
            </div>

            <button
              type="submit"
              className="btn btn-dark w-100"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>

          </form>

        </div>

      </div>
    );
  }
}

export default AdminLogin;